import {
  type BadgeProps,
  Badge as MantineBadge,
  type MantineStyleProps,
} from "@mantine/core";

export type UiBadgeVariant =
  | "success"
  | "warning"
  | "error"
  | "info"
  | "action"
  | "pending"
  | "teal"
  | "gray";

const variantColorMap: Record<UiBadgeVariant, string> = {
  success: "green",
  warning: "orange",
  error: "red",
  info: "blue",
  action: "violet",
  pending: "yellow",
  teal: "teal",
  gray: "gray",
};

type Props = {
  uiVariant?: UiBadgeVariant;
} & Omit<BadgeProps, "color" | "variant"> &
  MantineStyleProps;

export function UiBadge({ uiVariant = "teal", children, ...props }: Props) {
  return (
    <MantineBadge
      color={variantColorMap[uiVariant]}
      variant="light"
      radius="xl"
      size="sm"
      {...props}
    >
      {children}
    </MantineBadge>
  );
}
